import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsIconComponent, IconPipe } from './icon.component';

@NgModule({
    imports: [CommonModule],
    declarations: [AbsIconComponent, IconPipe],
    exports: [AbsIconComponent, IconPipe]
})
export class AbsIconModule {}
